import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SessionTaskBaseComponent } from '../session-task-base/session-task-base.component';
import { SessionTaskType } from '../session-task-types';

@Component({
  selector: 'session-task',
  imports: [
    CommonModule,
    SessionTaskBaseComponent
  ],
  template: `
  <session-task-base
    [taskType]="taskType()"
    [isCompleted]="isCompleted()"
    [isUrgent]="isUrgent()"
    [numberRemaining]="numberRemaining()"
  ></session-task-base>
  `
})
export class SessionTaskComponent {
  readonly taskType = input.required<SessionTaskType>();
  readonly isCompleted = input<boolean>(false);
  readonly numberRemaining = input<number>(0);

  // Alert/Attention decoration (a.k.a urgent) only opplies to account info task
  readonly isUrgent = computed(() => this.taskType() === SessionTaskType.ACCOUNT_INFO && !this.isCompleted());
}
